import * as zipcodes from 'zipcodes';
import tzlookup from 'tz-lookup';

export const DEFAULT_TIMEZONE = 'America/New_York';

/**
 * Best-effort US ZIP prefix → IANA timezone (mirrors leads-hub timezoneFromPrefix).
 */
const timezoneFromPrefix = (zipCode: string): string => {
  if (zipCode.length < 3) return '';

  const prefix = zipCode.slice(0, 3);

  if (
    (prefix >= '006' && prefix <= '049') ||
    (prefix >= '100' && prefix <= '289') ||
    (prefix >= '320' && prefix <= '329')
  ) {
    return 'America/New_York';
  }

  if (
    (prefix >= '350' && prefix <= '399') ||
    (prefix >= '500' && prefix <= '569') ||
    (prefix >= '600' && prefix <= '629') ||
    (prefix >= '630' && prefix <= '799')
  ) {
    return 'America/Chicago';
  }

  if (
    (prefix >= '590' && prefix <= '599') ||
    (prefix >= '800' && prefix <= '816') ||
    (prefix >= '820' && prefix <= '831') ||
    (prefix >= '832' && prefix <= '837') ||
    (prefix >= '840' && prefix <= '847') ||
    (prefix >= '870' && prefix <= '884')
  ) {
    return 'America/Denver';
  }

  if (prefix >= '850' && prefix <= '865') {
    return 'America/Phoenix';
  }

  if (
    prefix === '838' ||
    (prefix >= '889' && prefix <= '898') ||
    (prefix >= '900' && prefix <= '961') ||
    (prefix >= '970' && prefix <= '994')
  ) {
    return 'America/Los_Angeles';
  }

  if (prefix >= '995' && prefix <= '999') {
    return 'America/Anchorage';
  }

  if (prefix >= '967' && prefix <= '968') {
    return 'Pacific/Honolulu';
  }

  return '';
};

/**
 * Derives an IANA timezone from a US zip code (matches leads-hub derivation strategy).
 */
export const deriveTimezoneFromZip = (zipCode: string): string => {
  const normalized = zipCode.trim().split('-')[0];
  if (!normalized || normalized.length < 5) {
    return DEFAULT_TIMEZONE;
  }

  const zipData = zipcodes.lookup(normalized);
  if (zipData?.latitude && zipData?.longitude) {
    try {
      return tzlookup(zipData.latitude, zipData.longitude);
    } catch {
      // fall through to prefix/default
    }
  }

  const prefixTz = timezoneFromPrefix(normalized);
  return prefixTz || DEFAULT_TIMEZONE;
};
